const ROUTE_CONSTANTS = {
    ROOT: "/",
    ERROR: "/error",
    PET_FORM: "/mypet",
    CONVERSATIONAL_FORM: "/petForm",
    QUOTE: "/quote"
};

export default ROUTE_CONSTANTS;
